import React from "../../../../../pkg/react.js";
export const Leaf = ({
  attributes,
  children
}) => /* @__PURE__ */ React.createElement("span", {
  ...attributes
}, children);
